import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent, MessageBoxComponent } from '@sircon/sircon-ui-framework';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-lost-account-id-confirmation',
    templateUrl: './lost-account-id-confirmation.component.html',
    imports: [NgIf, MessageBoxComponent]
})
export class LostAccountIdConfirmationComponent extends BaseComponent {
    @Output() resend = new EventEmitter();
    @Output() startOver = new EventEmitter();
    @Input() emailAddress;
    @Input() resentSuccess = false;

    resendEmail() {
        this.resend.emit();
    }

    sendToNewEmail() {
        this.startOver.emit();
    }
}
